function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Children, PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { safeSelect } from '@sie/web-common-utils';

var parseAttrs = function parseAttrs(attrs) {
  return (attrs || '').trim().split(/\s+/).reduce(function (acc, cur) {
    var _cur$split = cur.split(/\s*=\s*/),
        _cur$split2 = _slicedToArray(_cur$split, 2),
        key = _cur$split2[0],
        value = _cur$split2[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value ? value.replace(/"/g, '') : true));
  }, {});
};
/**
 * Finds the first text node in a component tree
 * @param {ReactComponent} component - instance of a react component
 * @returns {String | Boolean} returns false if not found
 */


var findTextNode = function findTextNode(component) {
  var text = safeSelect(component, 'props.children');
  if (!text) return false;

  if (typeof text !== 'string') {
    return findTextNode(text);
  }

  return text;
};
/**
 * Replaces the text node found at the first or second level of component nesting
 * @param {ReactComponent} component - instance of a react component
 * @param {String} replacementText - the string to use as the label
 * @returns {ReactComponent}
 */


var replaceLabel = function replaceLabel(component, replacementText) {
  var text = safeSelect(component, 'props.children');
  if (!text) return component;

  if (typeof text !== 'string') {
    return /*#__PURE__*/cloneElement(component, {
      children: /*#__PURE__*/cloneElement(text, {
        children: replacementText
      })
    });
  }

  return /*#__PURE__*/cloneElement(component, {
    children: replacementText
  });
};
/**
 * Gensen strings can have embedded links in them. This component allows
 * for the Link component to be used inside one of these strings. In order
 * for this to work the link label must be an embedded string OR the embedded link
 * must have a data-label attribute that matches the passed link text. If this is not
 * true ask Copy to make it an embedded string (e.g. $$msgid_my_link_label) or add
 * the data-label attribute with the appropriate label to identify the link.
 *
 * ## Usage
 * ```jsx
 * <StringWithLink
 *  src="A message with <a href="blah" data-label="my-link">embedded link</a> in it.""
 * >
 *  <Link href="http://links.com/my-link">my-link</Link>
 * </StringWithLink>
 * ```
 *
 * ## Props
 */


var StringWithLink = /*#__PURE__*/function (_PureComponent) {
  _inherits(StringWithLink, _PureComponent);

  var _super = _createSuper(StringWithLink);

  function StringWithLink() {
    _classCallCheck(this, StringWithLink);

    return _super.apply(this, arguments);
  }

  _createClass(StringWithLink, [{
    key: "_interleaveLinks",
    value: function _interleaveLinks() {
      var _this$props = this.props,
          src = _this$props.src,
          children = _this$props.children;
      var links = Children.toArray(children).reduce(function (acc, el) {
        var linkText = findTextNode(el);
        if (typeof linkText !== 'string') return acc;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, linkText, el));
      }, {});
      return src.split(/(<a[^<>]*>[^<>]+<\/a>)/g).reduce(function (acc, cur) {
        if (cur.indexOf('<a') === 0) {
          var _splice = (cur.match(/(<a(.*)>(.*)<\/a>)/) || []).splice(2),
              _splice2 = _slicedToArray(_splice, 2),
              attrs = _splice2[0],
              _splice2$ = _splice2[1],
              label = _splice2$ === void 0 ? '' : _splice2$;

          var linkType = parseAttrs(attrs)['data-label'];
          var linkComponent = links[linkType] || links[label.trim()];
          if (!linkComponent) return acc.concat(label);
          return acc.concat(replaceLabel(linkComponent, label));
        }

        return acc.concat(cur);
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          className = _this$props2.className;
      return /*#__PURE__*/React.createElement("span", {
        "data-qa": qa,
        className: className
      }, this._interleaveLinks());
    }
  }]);

  return StringWithLink;
}(PureComponent);

export { StringWithLink as default };
StringWithLink.defaultProps = {
  qa: '',
  className: '',
  src: '',
  children: null
};
StringWithLink.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin
   */
  className: PropTypes.string,

  /**
   * The source string with or without embedded link
   */
  src: PropTypes.string,

  /**
   * children should be the links you'd like to replace within the string.
   * The label of link must match the one used in the string. This should be
   * an embedded string (e.g. $$msgid_some_string) so the match works across
   * all translations.
   */
  children: PropTypes.node
};